import React, { useState, useEffect } from "react";
import api from "../../configs/api";
import Swal from "sweetalert2";

const defaultTheme = {
  primaryColor: "#591f8b",
  primary2Color: "#916f9b",
  secondaryColor: "#e1e1e1",
};

const ThemeControl = () => {
  const [theme, setTheme] = useState({
    primaryColor: defaultTheme.primaryColor,
    primary2Color: defaultTheme.primary2Color,
    secondaryColor: defaultTheme.secondaryColor,
  });

  const setInitialTheme = async () => {
    try {
      await api.get("/theme").then((response) => {
        const theme = response.data;
        if (theme) {
          setTheme({
            primaryColor: theme.primaryColor,
            primary2Color: theme.primary2Color,
            secondaryColor: theme.secondaryColor,
          });
          document.documentElement.style.setProperty(
            "--primary-color",
            theme.primaryColor,
          );
          document.documentElement.style.setProperty(
            "--primary2-color",
            theme.primary2Color,
          );
          document.documentElement.style.setProperty(
            "--secondary-color",
            theme.secondaryColor,
          );
        }
      });
    } catch (error) {
      console.error("set theme error: ", error);
    }
  };

  useEffect(() => {
    setInitialTheme();
  }, []);

  const handleTheme = (IsReset) => {
    try {
      api.post("/theme", IsReset ? defaultTheme : theme).then((response) => {
        const theme = response.data;
        setTheme({
          primaryColor: theme.primaryColor,
          primary2Color: theme.primary2Color,
          secondaryColor: theme.secondaryColor,
        });
        document.documentElement.style.setProperty(
          "--primary1-color",
          theme.primaryColor,
        );
        document.documentElement.style.setProperty(
          "--primary2-color",
          theme.primary2Color,
        );
        document.documentElement.style.setProperty(
          "--secondary-color",
          theme.secondaryColor,
        );
      });

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Theme updated successfully",
        timer: 1000,
      });
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "something went wrong, please try again later",
        timer: 1000,
      });
      console.error("Save theme error: ", error);
    }
  };

  const handleThemeChange = (e) => {
    setTheme({ ...theme, [e.target.name]: e.target.value });
  };
  return (
    <div className='flex justify-between bg-primary4 m-10 p-10'>
      <div className='flex gap-4 items-center'>
        <div className='flex flex-col gap-4 justify-center items-center'>
          <label className='text-xl font-semibold text-gray-900'>
            Primary Color:
          </label>
          <input
            className='w-28 h-28'
            name='primaryColor'
            type='color'
            value={theme.primaryColor}
            onChange={handleThemeChange}
          />
        </div>
        <div className='flex flex-col gap-4 justify-center items-center'>
          <label className='text-xl font-semibold text-gray-900'>
            Primary 2 Color:
          </label>
          <input
            className='w-28 h-28'
            name='primary2Color'
            type='color'
            value={theme.primary2Color}
            onChange={handleThemeChange}
          />
        </div>
        <div className='flex flex-col gap-4 justify-center items-center'>
          <label className='text-xl font-semibold text-gray-900'>
            Secondary Color:
          </label>
          <input
            className='w-28 h-28'
            name='secondaryColor'
            type='color'
            value={theme.secondaryColor}
            onChange={handleThemeChange}
          />
        </div>
      </div>
      <div className='flex gap-4'>
        <button
          className='inline-flex items-center justify-center h-[40px] max-w-[1000px] px-3 py-2 text-sm font-medium text-center rounded-lg bg-primary hover:bg-[#3c2154] text-white    border-2 border-primary'
          onClick={() => handleTheme()}
        >
          Save
        </button>
        <button
          className='inline-flex items-center justify-center h-[40px] px-3 py-2 text-sm font-medium text-center rounded-lg text-primary hover:bg-[#3c2154] hover:text-white    sm:w-auto border-2 border-primary'
          onClick={() => handleTheme(true)}
        >
          Reset to default
        </button>
      </div>
    </div>
  );
};

export default ThemeControl;
